"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsSGPhoneNumber = exports.isSGPhoneNumber = void 0;
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const isString_1 = __importDefault(require("lodash/isString"));
const Exists_1 = require("../common/Exists");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const SG_NUMBER_REGEX = /(?!^\+65\d{6}$)^(?:\+?(?:65)?\D?([9,8,6,3]{1}\d{3}\D?\d{4})|((?:1[8,9]00)\D?\d{3}\D?\d{4})|(800\D?\d{3}\D?\d{4}))$/;
async function isSGPhoneNumber(value, args, constraints) {
    if ((0, isNumber_1.default)(value)) {
        value = value.toString();
    }
    const existsResults = await (0, Exists_1.exists)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
        allowEmptyString: false,
    });
    if (existsResults.pass === false || existsResults.skipped) {
        return existsResults;
    }
    if (!(0, isString_1.default)(value)) {
        return { pass: false, message: `should be a number or a string` };
    }
    if (!SG_NUMBER_REGEX.test(value)) {
        return { pass: false, message: `should be a valid SG phone number` };
    }
    return { pass: true };
}
exports.isSGPhoneNumber = isSGPhoneNumber;
/**
 * Validates that the value is a valid SG phone number
 */
function IsSGPhoneNumber(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsSGPhoneNumber",
        defaultMessage: `should be a valid SG phone number`,
        options,
        constraints,
        validateFn: isSGPhoneNumber,
    });
}
exports.IsSGPhoneNumber = IsSGPhoneNumber;
//# sourceMappingURL=IsSGPhoneNumber.js.map